export const NAV_FEATURES = {

    // ======================
    // CORE
    // ======================
    DASHBOARD: 'DASHBOARD',

    // ======================
    // USER SETTINGS
    // ======================
    ROUTES: 'ROUTES',
    FEATURES: 'FEATURES',
    SCREEN: 'SCREEN',
    SYNC: 'SYNC',
    BUSINESS_CATEGORIES: 'BUSINESS_CATEGORIES',
    BUSINESS_TYPES: 'BUSINESS_TYPES',
    PERSON_ROLES: 'PERSON_ROLES',

    // ======================
    // METRICS
    // ======================
    POND_METRICS: 'POND_METRICS',
    FEED_METRICS: 'FEED_METRICS',
    DENSITY_METRICS: 'DENSITY_METRICS',
    HARVEST_METRICS: 'HARVEST_METRICS',
    WATER_QUALITY_METRICS: 'WATER_QUALITY_METRICS',
    SAMPLING_METRICS: 'SAMPLING_METRICS',
    WATER_QUALITY_READINGS_METRICS: 'WATER_QUALITY_READINGS_METRICS',

    // ======================
    // MATERIAL MANAGEMENT
    // ======================
    TRANSACTION_TYPES: 'TRANSACTION_TYPES',
    UNITS_OF_MEASURES: 'UNITS_OF_MEASURES',
    SHAPES: 'SHAPES',
    ITEM_TYPES: 'ITEM_TYPES',
    PRODUCTS: 'PRODUCTS',
    
    // ======================
    // AQUACULTURE
    // ======================
    CULTURE_CATEGORIES: 'CULTURE_CATEGORIES',
    SPECIES_TYPES: 'SPECIES_TYPES',
    WATER_TYPES: 'WATER_TYPES',
    SOIL_TYPES: 'SOIL_TYPES',
    ACTIVITIES_LIST: 'ACTIVITIES_LIST',
    BROOD_BREEDERS: 'BROOD_BREEDERS',
    BROOD_LINES: 'BROOD_LINES',
    OBSERVATION_TYPES: 'OBSERVATION_TYPES',
    TREATMENT_TYPES: 'TREATMENT_TYPES',
    POND_TYPES: 'POND_TYPES',
    POND_USAGES: 'POND_USAGES',

    // ======================
    // BUSINESS MANAGEMENT
    // ======================
    QUICK_REGISTRATION: 'QUICK_REGISTRATION',
    BUSINESS_ENTITIES: 'BUSINESS_ENTITIES',
    PERSONS: 'PERSONS',
    YOUR_FIELD_FORCE: 'YOUR_FIELD_FORCE',
    YOUR_CUSTOMERS: 'YOUR_CUSTOMERS',
    FARM_USERS: 'FARM_USERS',
    YOUR_BUSINESS: 'YOUR_BUSINESS',

    // ======================
    // VISITS, ORDERS AND ACTIVITY_TRACKER_LEADS
    // ======================
    VISITS: 'VISITS',
    ORDERS: 'ORDERS',
    ACTIVITY_TRACKER_LEADS: 'ACTIVITY_TRACKER_LEADS',

    // ======================
    // BARCODE
    // ======================
    BARCODES: 'BARCODES',

    // ======================
    // REPORTS
    // ======================
    CULTURE_SUMMARY: 'CULTURE_SUMMARY',
    POND_SUMMARY: 'POND_SUMMARY',
    DAY_SUMMARY: 'DAY_SUMMARY',
    TRACEABILITY_SUMMARY: 'TRACEABILITY_SUMMARY',
} as const;

export type NavFeature =
    typeof NAV_FEATURES[keyof typeof NAV_FEATURES];

export type AppFeature = NavFeature